import { Reveal } from '../shared/reveal/reveal';

export function About() {
  return (
    <section id="about" className="mx-auto max-w-content px-5 py-16">
      <Reveal>
        <p className="section-kicker">{'// 01 — about'}</p>
        <h2 className="mt-2 font-mono text-2xl font-bold tracking-tight text-fg sm:text-3xl">
          About me
        </h2>
      </Reveal>

      <Reveal delay={80}>
        <div className="terminal-card mt-6 p-6 sm:p-8">
          <p className="max-w-3xl text-lg leading-relaxed text-fg/90">
            Hi, I&apos;m <span className="text-accent">Nick Gardner</span>, a{' '}
            <span className="text-accent">Senior Software Engineer</span> working in public safety.
            I build enterprise applications that local governments rely on day to day, and I like
            owning the whole thing: the interface people use, the data and API layers underneath,
            and the cloud infrastructure it runs on.
          </p>
          <p className="mt-4 max-w-3xl text-lg leading-relaxed text-muted">
            Off the clock I&apos;m usually still building something, mostly web apps and sites these
            days, with the occasional microcontroller project on the side. Some of it ended up
            below: React and Angular takes on the same app, a portal for my home IoT devices, and a
            couple of npm packages that quietly host this site and its blog. Feel free to reach out;
            my LinkedIn and GitHub are up top.
          </p>
        </div>
      </Reveal>
    </section>
  );
}
